// extracted by mini-css-extract-plugin
module.exports = {"root":"📦BottleCard__root--3zRWj","labelledValue":"📦BottleCard__labelledValue--2GUdM"};